"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableCell = void 0;
var classnames_1 = require("classnames");
var PropTypes = require("prop-types");
var React = require("react");
var TableColumn_1 = require("./TableColumn");
var TableCell = function (_a) {
    var children = _a.children, isHeader = _a.isHeader, isSelected = _a.isSelected, alignment = _a.alignment, ariaColIndex = _a.ariaColIndex, ariaRowIndex = _a.ariaRowIndex;
    var tableCellClasses = (0, classnames_1.default)('table__cell', {
        'table__cell--center': alignment === TableColumn_1.Alignment.CENTER,
        'table__cell--end': alignment === TableColumn_1.Alignment.END,
        'table__cell--header': isHeader,
        'table__cell--selected': isSelected,
        'table__cell--start': !alignment || alignment === TableColumn_1.Alignment.START,
    });
    var attributes = {
        className: tableCellClasses,
        role: isHeader ? 'columnheader' : 'cell',
    };
    if (ariaColIndex) {
        attributes['aria-colindex'] = ariaColIndex;
    }
    if (ariaRowIndex) {
        attributes['aria-rowindex'] = ariaRowIndex;
    }
    return (React.createElement("div", __assign({}, attributes), children));
};
exports.TableCell = TableCell;
exports.TableCell.defaultProps = {
    isHeader: false,
    isSelected: false,
};
exports.TableCell.propTypes = {
    alignment: PropTypes.oneOf(Object.values(TableColumn_1.Alignment)),
    ariaColIndex: PropTypes.number,
    ariaRowIndex: PropTypes.number,
    isHeader: PropTypes.bool,
    isSelected: PropTypes.bool,
};
